import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import Select from "react-select";
import { v4 as uuidv4 } from "uuid";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import "../../../index.css";
import { url, url3 } from '../../../Config';

import Box from "@mui/material/Box";
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import IconButton from "@mui/material/IconButton";


export default function FS_test(props) {

    // ============================================================
    // BASIC DATA STATES
    // ============================================================

    const [apidata, setapidata] = useState([]);

    const [group, setgroup] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);

    const [mainsector, setmainsector] = useState([]);
    const [selectedMainSector, setselectedMainSector] = useState(null);

    const [sector, setsector] = useState([]);
    const [selectedSector, setselectedSector] = useState(null);

    const [scale, setscale] = useState([]);
    const [selectedScale, setselectedScale] = useState([]);

    const [opinion, setopinion] = useState([]);
    const [selectedOpinion, setselectedOpinion] = useState([]);

    const [period, setperiod] = useState([]);
    const [selectedPeriod, setselectedPeriod] = useState([]);

    const [period_data, setperiod_data] = useState({});
    const [singleperiod_data, setsingleperiod_data] = useState([]);

    const [periodtitle, setperiodtitle] = useState([]);
    const [periodlabel, setperiodlabel] = useState([]);

    const [opinionarr, setopinionarr] = useState([]);
    const [comparisondata, setcomparisondata] = useState([]);

    const [COLUMN_WIDTH, setCOLUMN_WIDTH] = useState(300);

    const [loading, setloading] = useState("loading");

    const [newperiod2, setnewperiod2] = useState([]);
    const [newopinion, setnewopinion] = useState([]);

    const [bool, setbool] = useState(false);

    const [scale_opinion, setscale_opinion] = useState([]);

    const [showFilters, setShowFilters] = useState(true);

    const [pacra, setpacra] = useState(0);
    const [other, setother] = useState(0);
    const [vis, setvis] = useState(0);

    const [alertopen, setalertOpen] = useState(false);
    const [alertType, setalertType] = useState();
    const [AlertMessage, setalertmessage] = useState();

    const [hiddenPeriods, setHiddenPeriods] = useState({});

    const inputRef = useRef(null);
    const rationRef = useRef(null);


    // ============================================================
    // ROW FORMULA / ADDITION STATES
    // ============================================================

    const [addSource1, setAddSource1] = useState("1. Non-Current Assets");
    const [addSource2, setAddSource2] = useState("2. Investments");
    const [addSource3, setAddSource3] = useState("3. Related Party Exposure");
    const [addSource4, setAddSource4] = useState("4. Current Assets");
    const [addTarget, setAddTarget] = useState("a. Inventories");
    const [addTarget2, setAddTarget2] = useState("b. Trade Receivables");


    const[return_on_equity_source1, setReturn_on_equity_source1] = useState("6. Net Income Or (Loss)");
    const[return_on_equity_source2, setReturn_on_equity_source2] = useState("11. Shareholders' Equity");
    const[return_on_equity_target, setReturn_on_equity_target] = useState("e. Return on Equity [ Net Profit Margin * Asset Turnover * (Total Assets/Shareholders' Equity )]");
    /*
        Example:

        {
            "7. Borrowings": {
                operation: "add",
                sources: [
                    "2. Investments",
                    "4. Current Assets"
                ]
            }
        }
    */

    const [rowFormulas, setRowFormulas] = useState({});


    // ============================================================
    // LOAD API DATA
    // ============================================================

    const func = async () => {

        try {

            setloading("loading");


            // ----------------------------------------------------
            // GET PACRA DATA
            // ----------------------------------------------------

            const res = await axios.get(
                `https://209.97.168.200/pacrawizpackv3/public/get-fs-data`
            );

            let resp = Array.isArray(res.data)
                ? res.data
                : [];


            // ----------------------------------------------------
            // KEEP LATEST RECORD FOR EACH OPINION
            // ----------------------------------------------------

            const resultMap = new Map();

            for (const item of resp) {

                if (!item) {
                    continue;
                }

                const existing =
                    resultMap.get(item.opinion_id);

                if (
                    !existing ||
                    item.record_id > existing.record_id
                ) {

                    resultMap.set(
                        item.opinion_id,
                        item
                    );

                }

            }

            resp = Array.from(
                resultMap.values()
            );


            // ----------------------------------------------------
            // GET NEW PERIOD DATA
            // ----------------------------------------------------

            const res2 = await axios.get(
                `${url3}/api/get_research_new_period`
            );

            const responseData =
                res2 &&
                res2.data
                    ? res2.data
                    : {};

            const resp2 =
                Array.isArray(responseData.data)
                    ? responseData.data
                    : [];

            const resp3 =
                Array.isArray(responseData.otherop)
                    ? responseData.otherop
                    : [];


            // ----------------------------------------------------
            // MERGE NEW PERIOD DATA INTO PACRA
            // ----------------------------------------------------

            for (
                let i = 0;
                i < resp.length;
                i++
            ) {

                resp[i].opinion = 'PACRA';

                if (!resp[i].data) {
                    resp[i].data = {};
                }


                for (
                    let j = 0;
                    j < resp2.length;
                    j++
                ) {

                    if (
                        `${resp[i].opinion_id}` ===
                        `${resp2[j].opinion_id}`
                    ) {

                        let currentPeriod =
                            resp2[j].period_name;

                        if (
                            typeof currentPeriod ===
                            "string"
                        ) {

                            currentPeriod =
                                currentPeriod.replace(
                                    ' ',
                                    '  '
                                );

                        }

                        resp[i].data[
                            currentPeriod
                        ] = resp2[j].data;

                    }

                }

            }


            // ----------------------------------------------------
            // BUILD OTHER OPINIONS
            // ----------------------------------------------------

            for (
                let i = 0;
                i < resp3.length;
                i++
            ) {

                const otherItem = resp3[i];

                otherItem.opinion_id =
                    otherItem.id2;

                otherItem.data = {};


                for (
                    let j = 0;
                    j < resp2.length;
                    j++
                ) {

                    if (
                        `${otherItem.id2}` ===
                        `${resp2[j].opinion_id}`
                    ) {

                        let currentPeriod =
                            resp2[j].period_name;

                        if (
                            typeof currentPeriod ===
                            "string"
                        ) {

                            currentPeriod =
                                currentPeriod.replace(
                                    ' ',
                                    '  '
                                );

                        }

                        otherItem.group =
                            resp2[j].group;

                        otherItem.main_sector =
                            resp2[j].main_sector;

                        otherItem.sector =
                            resp2[j].sector;

                        otherItem.scale =
                            "Entity";

                        otherItem.opinion =
                            resp2[j].opinion_of;

                        otherItem.data[
                            currentPeriod
                        ] = resp2[j].data;

                    }

                }

            }


            // ----------------------------------------------------
            // MERGE EVERYTHING
            // ----------------------------------------------------

            const merged = [
                ...resp,
                ...resp3
            ];


            setapidata(merged);


            // ----------------------------------------------------
            // BUILD UNIQUE GROUPS
            // ----------------------------------------------------

            const seen = new Set();

            const uniquegroupArray = [];


            merged.forEach((item) => {

                if (!item) {
                    return;
                }

                const groupvar =
                    item.group;


                if (
                    groupvar &&
                    typeof groupvar === "string" &&
                    groupvar.trim() !== ""
                ) {

                    const groupLower =
                        groupvar.toLowerCase();


                    if (
                        !seen.has(groupLower)
                    ) {

                        seen.add(groupLower);

                        uniquegroupArray.push({
                            value: uuidv4(),
                            label: groupvar
                        });

                    }

                }

            });


            setgroup(
                uniquegroupArray
            );


            setloading("loaded");

        } catch (error) {

            console.error(
                "Error loading FS data:",
                error
            );

            setloading("loaded");

        }

    };


    // ============================================================
    // INITIAL LOAD
    // ============================================================

    useEffect(() => {

        func();

    }, []);


    // ============================================================
    // PERIOD VISIBILITY
    // ============================================================

    const togglePeriod = (
        opinionName,
        currentPeriod
    ) => {

        setHiddenPeriods((previous) => {

            const currentHidden =
                previous[opinionName] || [];


            if (
                currentHidden.includes(
                    currentPeriod
                )
            ) {

                return {
                    ...previous,

                    [opinionName]:
                        currentHidden.filter(
                            (p) =>
                                p !== currentPeriod
                        )
                };

            }


            return {
                ...previous,

                [opinionName]: [
                    ...currentHidden,
                    currentPeriod
                ]
            };

        });

    };


    // const getVisiblePeriods = (
    //     opinionName
    // ) => {

    //     const hidden =
    //         hiddenPeriods[opinionName] || [];


    //     return periodlabel.filter(
    //         (currentPeriod) =>
    //             !hidden.includes(
    //                 currentPeriod
    //             )
    //     );

    // };

    const getVisiblePeriods = (opinionName) => {
        const hidden = hiddenPeriods[opinionName] || [];

        const currentOpinion = comparisondata.find(
            (op) => op.name === opinionName
        );

        // Use only periods available for this opinion.
        const availablePeriods = currentOpinion
            ? currentOpinion.periods
            : periodlabel;

        return availablePeriods.filter(
            (currentPeriod) => !hidden.includes(currentPeriod)
        );
    };

    const isPeriodHidden = (
        opinionName,
        currentPeriod
    ) => {

        return (
            hiddenPeriods[opinionName] || []
        ).includes(
            currentPeriod
        );

    };


    // ============================================================
    // GROUP SELECT
    // ============================================================

    const handleSelect = (data) => {

        setalertOpen(false);

        setSelectedGroup(data);


        setmainsector([]);
        setselectedMainSector(null);

        setscale([]);
        setselectedScale([]);

        setsector([]);
        setselectedSector(null);

        setopinion([]);
        setselectedOpinion([]);

        setperiod([]);
        setselectedPeriod([]);

        setperiodlabel([]);


        if (!data) {
            return;
        }


        const arr = [];


        for (
            let i = 0;
            i < apidata.length;
            i++
        ) {

            if (
                apidata[i] &&
                apidata[i].group === data.label
            ) {

                arr.push(
                    apidata[i]
                );

            }

        }


        const seen = new Set();

        const uniquemainsectorArray = [];


        arr.forEach((item) => {

            const mainsectorvar =
                item.main_sector;


            if (
                mainsectorvar &&
                typeof mainsectorvar === "string" &&
                mainsectorvar.trim() !== ""
            ) {

                const mainsectorLower =
                    mainsectorvar.toLowerCase();


                if (
                    !seen.has(
                        mainsectorLower
                    )
                ) {

                    seen.add(
                        mainsectorLower
                    );

                    uniquemainsectorArray.push({
                        value: mainsectorvar,
                        label: mainsectorvar
                    });

                }

            }

        });


        setmainsector(
            uniquemainsectorArray
        );

    };


    // ============================================================
    // MAIN SECTOR SELECT
    // ============================================================

    const handleSelect2 = (data) => {

        setalertOpen(false);

        setselectedMainSector(data);


        setsector([]);
        setselectedSector(null);

        setscale([]);
        setselectedScale([]);

        setopinion([]);
        setselectedOpinion([]);

        setperiod([]);
        setselectedPeriod([]);

        setperiodlabel([]);


        if (!data) {
            return;
        }


        const arr = [];


        for (
            let i = 0;
            i < apidata.length;
            i++
        ) {

            if (
                apidata[i] &&
                apidata[i].main_sector ===
                    data.label
            ) {

                arr.push(
                    apidata[i]
                );

            }

        }


        const seen = new Set();

        const uniquesectorArray = [];


        arr.forEach((item) => {

            const sectorvar =
                item.sector;


            if (
                sectorvar &&
                typeof sectorvar === "string" &&
                sectorvar.trim() !== ""
            ) {

                const sectorLower =
                    sectorvar.toLowerCase();


                if (
                    !seen.has(
                        sectorLower
                    )
                ) {

                    seen.add(
                        sectorLower
                    );

                    uniquesectorArray.push({
                        value: sectorvar,
                        label: sectorvar
                    });

                }

            }

        });


        setsector(
            uniquesectorArray
        );

    };


    // ============================================================
    // SECTOR SELECT
    // ============================================================

    const handleSelect3 = (data) => {

        setalertOpen(false);

        setselectedSector(data);


        setscale([]);
        setselectedScale([]);

        setopinion([]);
        setselectedOpinion([]);

        setperiod([]);
        setselectedPeriod([]);

        setperiodlabel([]);


        if (!data) {

            setscale_opinion([]);

            return;

        }


        const arr = [];


        for (
            let i = 0;
            i < apidata.length;
            i++
        ) {

            if (
                apidata[i] &&
                apidata[i].sector ===
                    data.label
            ) {

                arr.push(
                    apidata[i]
                );

            }

        }


        console.log(
            arr,
            "arr"
        );


        setscale_opinion(
            arr
        );


        const seen = new Set();

        const uniquescaleArray = [];


        arr.forEach((item) => {

            const scalevar =
                item.scale;


            if (
                scalevar &&
                typeof scalevar === "string" &&
                scalevar.trim() !== ""
            ) {

                const scaleLower =
                    scalevar.toLowerCase();


                if (
                    !seen.has(
                        scaleLower
                    )
                ) {

                    seen.add(
                        scaleLower
                    );

                    uniquescaleArray.push({
                        value: scalevar,
                        label: scalevar
                    });

                }

            }

        });


        setscale(
            uniquescaleArray
        );

    };


    // ============================================================
    // SCALE SELECT
    // ============================================================

    const handleSelect4 = (data) => {

        setalertOpen(false);

        setselectedScale(
            data || []
        );


        setopinion([]);
        setselectedOpinion([]);

        setperiod([]);
        setselectedPeriod([]);

        setperiodlabel([]);


        if (
            !data ||
            data.length === 0
        ) {

            setopinion([]);

            return;

        }


        const arr = [];


        for (
            let i = 0;
            i < data.length;
            i++
        ) {

            for (
                let j = 0;
                j < scale_opinion.length;
                j++
            ) {

                if (
                    scale_opinion[j] &&
                    scale_opinion[j].scale ===
                        data[i].label
                ) {

                    arr.push(
                        scale_opinion[j]
                    );

                }

            }

        }


        const seen = new Set();

        const uniqueopinionArray = [];
        const uniqueopinionArray2 = [];


        uniqueopinionArray.push({
            value: '*',
            label: 'Select All'
        });


        arr.forEach((item) => {

            if (!item) {
                return;
            }


            const opinionvar =
                item.opinion_name;

            const opinionof =
                item.opinion;


            let recordid = null;


            if (
                item.record_id !== undefined
            ) {

                recordid =
                    item.record_id;

            } else {

                if (
                    item.opinion_of === "VIS" ||
                    item.opinion_of === "Other"
                ) {

                    recordid =
                        item.id2;

                }

            }


            if (
                opinionvar &&
                typeof opinionvar === "string" &&
                opinionvar.trim() !== ""
            ) {

                const opinionLower =
                    opinionvar.toLowerCase();


                if (
                    !seen.has(
                        opinionLower
                    )
                ) {

                    seen.add(
                        opinionLower
                    );


                    uniqueopinionArray.push({
                        value: recordid,
                        label: opinionvar
                    });


                    uniqueopinionArray2.push({
                        recordid: recordid,
                        name: opinionvar,
                        opinionof: opinionof
                    });

                }

            }

        });


        uniqueopinionArray.sort(
            (a, b) => {

                if (
                    a.label ===
                    'Select All'
                ) {
                    return -1;
                }

                if (
                    b.label ===
                    'Select All'
                ) {
                    return 1;
                }

                return a.label.localeCompare(
                    b.label
                );

            }
        );


        const counts =
            uniqueopinionArray2.reduce(
                (acc, item) => {

                    acc[item.opinionof] =
                        (
                            acc[item.opinionof] ||
                            0
                        ) + 1;

                    return acc;

                },
                {}
            );


        setpacra(
            counts.PACRA || 0
        );

        setother(
            counts.Other || 0
        );

        setvis(
            counts.VIS || 0
        );


        setopinion(
            uniqueopinionArray
        );

    };


    // ============================================================
    // DATE EXTRACTION
    // ============================================================

    function extractDate(str) {

        if (
            typeof str !== "string"
        ) {

            return new Date(0);

        }


        const match =
            str.match(
                /([A-Za-z]{3})-(\d{2})/
            );


        if (!match) {

            return new Date(0);

        }


        const monthStr =
            match[1];

        const yearStr =
            match[2];


        const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];


        const month =
            months.indexOf(
                monthStr
            );


        const year =
            parseInt(
                yearStr,
                10
            ) + 2000;


        return new Date(
            year,
            month
        );

    }


    // ============================================================
    // OPINION SELECT
    // ============================================================

    const handleSelect5 = (data) => {

        setalertOpen(false);

        setnewopinion(
            data || []
        );


        if (!data) {

            setselectedOpinion([]);

            setperiod([]);
            setselectedPeriod([]);

            setperiodlabel([]);

            return;

        }


        let newdata = [];


        const isSelectAllSelected =
            data.some(
                (opt) =>
                    opt.value === '*'
            );


        const isCurrentlyAllSelected =
            selectedOpinion.length ===
            opinion.length - 1;


        if (
            isSelectAllSelected &&
            !isCurrentlyAllSelected
        ) {

            newdata =
                opinion.filter(
                    (opt) =>
                        opt.value !== '*'
                );


            setselectedOpinion(
                newdata
            );

        } else if (
            isSelectAllSelected &&
            isCurrentlyAllSelected
        ) {

            setselectedOpinion([]);

            newdata = [];

        } else {

            newdata =
                data.filter(
                    (opt) =>
                        opt.value !== '*'
                );


            setselectedOpinion(
                newdata
            );

        }


        setperiod([]);
        setselectedPeriod([]);
        setperiodlabel([]);


        const arr = [];
        const perioddataarr = [];
        const opinionarr2 = [];


        for (
            let i = 0;
            i < newdata.length;
            i++
        ) {

            const selectedOpinionName =
                newdata[i].label;


            for (
                let j = 0;
                j < apidata.length;
                j++
            ) {

                const item =
                    apidata[j];


                if (
                    item &&
                    item.opinion_name ===
                        selectedOpinionName
                ) {

                    const itemData =
                        item.data &&
                        typeof item.data ===
                            "object"
                            ? item.data
                            : {};


                    const key =
                        Object.keys(
                            itemData
                        );


                    arr.push(key);

                    perioddataarr.push(
                        itemData
                    );


                    opinionarr2.push({
                        opinion_name:
                            item.opinion_name,

                        opinion_id:
                            item.opinion_id,

                        opinion:
                            item.opinion,

                        legal_status:
                            item.legal_status
                    });

                }

            }

        }


        setopinionarr(
            opinionarr2
        );

        setperiod_data(
            perioddataarr
        );


        console.log(
            perioddataarr,
            "perioddataarr"
        );


        if (
            !arr.length
        ) {

            return;

        }


        // --------------------------------------------------------
        // GET ALL UNIQUE PERIODS
        // --------------------------------------------------------

        const rawResult =
            Array.from(
                new Set(
                    arr.reduce(
                        (result, current) => {

                            return result.concat(
                                Array.isArray(current)
                                    ? current
                                    : []
                            );

                        },
                        []
                    )
                )
            );


        // --------------------------------------------------------
        // SORT PERIODS DESCENDING
        // --------------------------------------------------------

        const sorted =
            rawResult.sort(
                (a, b) =>
                    extractDate(b) -
                    extractDate(a)
            );


        const latest =
            sorted.length > 0
                ? sorted[0]
                : null;


        const arrfinal =
            sorted.map(
                (label) => ({

                    value: uuidv4(),

                    label: label,

                    highlight:
                        label === latest

                })
            );


        const selectAllOption = {
            value: '*',
            label: 'Select All'
        };


        setperiod([
            selectAllOption,
            ...arrfinal
        ]);

    };
    // ============================================================
    // PERIOD SELECT
    // ============================================================

    const handleSelect6 = (data) => {

        setalertOpen(false);

        setnewperiod2(
            data || []
        );


        if (!data) {

            setselectedPeriod([]);

            setperiodtitle([]);

            setperiodlabel([]);

            setcomparisondata([]);

            return;

        }


        let newdata = [];


        const isSelectAllSelected =
            data.some(
                (opt) =>
                    opt.value === '*'
            );


        const isCurrentlyAllSelected =
            selectedPeriod.length ===
            period.length - 1;


        if (
            isSelectAllSelected &&
            !isCurrentlyAllSelected
        ) {

            newdata =
                period.filter(
                    (opt) =>
                        opt.value !== '*'
                );


            setselectedPeriod(
                newdata
            );

        } else if (
            isSelectAllSelected &&
            isCurrentlyAllSelected
        ) {

            newdata = [];

            setselectedPeriod([]);

        } else {

            newdata =
                data.filter(
                    (opt) =>
                        opt.value !== '*'
                );


            setselectedPeriod(
                newdata
            );

        }


        // --------------------------------------------------------
        // PERIOD LABELS
        // --------------------------------------------------------

        const keys = [];


        for (
            let i = 0;
            i < newdata.length;
            i++
        ) {

            keys.push(
                newdata[i].label
            );

        }


        setperiodtitle(keys);

        setperiodlabel(keys);


        if (
            keys.length === 0
        ) {

            setcomparisondata([]);

            return;

        }


        // --------------------------------------------------------
        // SAFELY GET PERIOD DATA
        // --------------------------------------------------------

        const newperiod_data =
            Array.isArray(period_data)
                ? period_data
                : [];


       
        const normalizedPeriodData = Array.isArray(period_data)
            ? period_data
            : [];

        // Keep the selected periods unchanged
        const keysToUse = keys;

        setperiodtitle(keysToUse);
        setperiodlabel(keysToUse);

        // Find opinions containing at least one selected period
        const filteredOpinionIndexes = [];

        for (let i = 0; i < opinionarr.length; i++) {
            const opinionData = normalizedPeriodData[i];

            if (
                opinionData &&
                keysToUse.some((periodKey) =>
                    Object.prototype.hasOwnProperty.call(
                        opinionData,
                        periodKey
                    )
                )
            ) {
                filteredOpinionIndexes.push(i);
            }
        }

        if (filteredOpinionIndexes.length === 0) {
            setcomparisondata([]);
            return;
        }




        // --------------------------------------------------------
        // BUILD ONE DATA STRUCTURE PER OPINION
        // --------------------------------------------------------

        const arraybasedonOP = [];


        for (const i of filteredOpinionIndexes) {

            const result2 = [];

            const sectionMap =
                new Map();

            const lookups = [];


            // ----------------------------------------------------
            // SAFELY GET THIS OPINION'S PERIOD DATA
            // ----------------------------------------------------

            const opinionPeriodData =
                normalizedPeriodData[i] || {};

            const opinionPeriods = keysToUse.filter(
                (periodKey) =>
                    Object.prototype.hasOwnProperty.call(
                        opinionPeriodData,
                        periodKey
                    )
            );


            // ----------------------------------------------------
            // BUILD LOOKUPS FOR EACH SELECTED PERIOD
            // ----------------------------------------------------

            for (let k = 0; k < keysToUse.length; k++) {
                const key = keysToUse[k];

                // Keep the data index aligned with the global period order.
                // Missing periods will not be displayed for this opinion.
                if (
                    !Object.prototype.hasOwnProperty.call(
                        opinionPeriodData,
                        key
                    )
                ) {
                    lookups.push({});
                    continue;
                }

                let currentArray = opinionPeriodData[key];

                // Keep your existing code here that processes currentArray,
                // builds map, and pushes map into lookups.


                if (
                    !Array.isArray(
                        currentArray
                    )
                ) {

                    currentArray = [];

                }


                // ------------------------------------------------
                // Remove unnecessary header
                // ------------------------------------------------

                if (
                    currentArray.length > 0 &&
                    Array.isArray(
                        currentArray[0]
                    ) &&
                    currentArray[0][0] === ''
                ) {

                    currentArray =
                        currentArray.slice(1);

                }


                const map = {};

                let currentSection = null;


                for (
                    let r = 0;
                    r < currentArray.length;
                    r++
                ) {

                    const row =
                        currentArray[r];


                    if (
                        !Array.isArray(row) ||
                        row.length === 0
                    ) {

                        continue;

                    }


                    // --------------------------------------------
                    // Section header
                    // --------------------------------------------

                    if (
                        row.length === 1
                    ) {

                        currentSection =
                            row[0];


                        if (
                            !sectionMap.has(
                                currentSection
                            )
                        ) {

                            sectionMap.set(
                                currentSection,
                                []
                            );

                        }

                    }

                    // --------------------------------------------
                    // Normal row
                    // --------------------------------------------

                    else {

                        const id =
                            row[0];

                        const val =
                            row[1];


                        if (
                            currentSection !== null &&
                            currentSection !== undefined
                        ) {

                            const sectionRows =
                                sectionMap.get(
                                    currentSection
                                );


                            if (
                                sectionRows &&
                                !sectionRows.includes(
                                    id
                                )
                            ) {

                                sectionRows.push(id);

                            }

                        }


                        if (
                            !map[id]
                        ) {

                            map[id] = {};

                        }


                        map[id][
                            currentSection
                        ] = val;

                    }

                }


                lookups.push(map);

            }


            // ----------------------------------------------------
            // BUILD RESULT FOR THIS OPINION
            // ----------------------------------------------------

            for (
                const sectionEntry of sectionMap.entries()
            ) {

                const section =
                    sectionEntry[0];

                const ids =
                    sectionEntry[1];


                result2.push([
                    section
                ]);


                for (
                    let r = 0;
                    r < ids.length;
                    r++
                ) {

                    const id =
                        ids[r];


                    const row = [
                        id
                    ];


                    for (
                        let m = 0;
                        m < lookups.length;
                        m++
                    ) {

                        const map =
                            lookups[m];


                        if (
                            map[id] &&
                            Object.prototype.hasOwnProperty.call(
                                map[id],
                                section
                            )
                        ) {

                            row.push(
                                map[id][section]
                            );

                        } else {

                            row.push(0);

                        }

                    }


                    result2.push(
                        row
                    );

                }

            }


            arraybasedonOP.push({
                name: opinionarr[i].opinion_name,
                periods: opinionPeriods,
                data: result2,
                opinion_id: opinionarr[i].opinion_id,
                opinion: opinionarr[i].opinion,
                legal_status: opinionarr[i].legal_status
            });

        }


        // ========================================================
        // IMPORTANT FIX
        //
        // DO NOT USE THE LONGEST OPINION AS THE TEMPLATE.
        //
        // Instead, collect the UNION of all sections and rows.
        // This prevents rows such as:
        //
        // 2. Investments
        // 4. Current Assets
        // 7. Borrowings
        //
        // from disappearing.
        // ========================================================

        const globalSectionMap =
            new Map();


        // --------------------------------------------------------
        // FIRST PASS:
        // Collect EVERY section and EVERY row
        // --------------------------------------------------------

        for (
            let i = 0;
            i < arraybasedonOP.length;
            i++
        ) {

            const currentOpinion =
                arraybasedonOP[i];


            if (
                !currentOpinion ||
                !Array.isArray(
                    currentOpinion.data
                )
            ) {

                continue;

            }


            let currentSection = null;


            for (
                let r = 0;
                r < currentOpinion.data.length;
                r++
            ) {

                const row =
                    currentOpinion.data[r];


                if (
                    !Array.isArray(row) ||
                    row.length === 0
                ) {

                    continue;

                }


                if (
                    row.length === 1
                ) {

                    currentSection =
                        row[0];


                    if (
                        !globalSectionMap.has(
                            currentSection
                        )
                    ) {

                        globalSectionMap.set(
                            currentSection,
                            []
                        );

                    }

                } else {

                    if (
                        currentSection !== null &&
                        currentSection !== undefined
                    ) {

                        const rowId =
                            row[0];


                        if (
                            rowId !== undefined &&
                            rowId !== null &&
                            rowId !== "" &&
                            !globalSectionMap
                                .get(currentSection)
                                .includes(rowId)
                        ) {

                            globalSectionMap
                                .get(currentSection)
                                .push(rowId);

                        }

                    }

                }

            }

        }


        // --------------------------------------------------------
        // SECOND PASS:
        // Rebuild EVERY opinion using UNION structure
        // --------------------------------------------------------

        for (
            let i = 0;
            i < arraybasedonOP.length;
            i++
        ) {

            const currentOpinion =
                arraybasedonOP[i];


            if (
                !currentOpinion ||
                !Array.isArray(
                    currentOpinion.data
                )
            ) {

                continue;

            }


            // --------------------------------------------
            // Build lookup for this opinion
            // --------------------------------------------

            const rowMap =
                new Map();


            let currentSection = null;


            for (
                let r = 0;
                r < currentOpinion.data.length;
                r++
            ) {

                const row =
                    currentOpinion.data[r];


                if (
                    !Array.isArray(row) ||
                    row.length === 0
                ) {

                    continue;

                }


                if (
                    row.length === 1
                ) {

                    currentSection =
                        row[0];

                } else {

                    if (
                        currentSection !== null &&
                        currentSection !== undefined
                    ) {

                        const key =
                            currentSection +
                            ":" +
                            row[0];


                        rowMap.set(
                            key,
                            row
                        );

                    }

                }

            }


            // --------------------------------------------
            // Rebuild normalized opinion
            // --------------------------------------------

            const normalizedOpinion = [];


            for (
                const sectionEntry of globalSectionMap.entries()
            ) {

                const sectionName =
                    sectionEntry[0];

                const rowIds =
                    sectionEntry[1];


                // Section header

                normalizedOpinion.push([
                    sectionName
                ]);


                // All rows belonging to section

                for (
                    let r = 0;
                    r < rowIds.length;
                    r++
                ) {

                    const rowId =
                        rowIds[r];


                    const key =
                        sectionName +
                        ":" +
                        rowId;


                    const original =
                        rowMap.get(key);


                    if (original) {

                        normalizedOpinion.push(
                            original
                        );

                    } else {

                        // ----------------------------------------
                        // IMPORTANT:
                        // Keep missing rows.
                        // Fill them with zeroes.
                        // ----------------------------------------

                        normalizedOpinion.push([
                            rowId,
                            ...Array(keysToUse.length).fill(0)
                        ]);

                    }

                }

            }


            currentOpinion.data =
                normalizedOpinion;

        }


        console.log(
            "FINAL COMPARISON DATA:",
            arraybasedonOP
        );


        setcomparisondata(
            arraybasedonOP
        );
        returnOnEquity();
        // handleAddRows();
        // console.log(rationRef.current,"click");
        // rationRef.current.click();

    };


    // ============================================================
    // FORMATTING HELPERS
    // ============================================================

    function normalizeValue(val) {

        if (
            val === null ||
            val === undefined ||
            val === '' ||
            val === 'NA' ||
            val === 'N/A'
        ) {

            return 0;

        }


        if (
            typeof val === "string"
        ) {

            let clean =
                val.trim();


            if (
                clean === ""
            ) {

                return 0;

            }


            // Percentage

            if (
                clean.includes('%')
            ) {

                return Math.round(
                    parseFloat(
                        clean.replace(
                            '%',
                            ''
                        )
                    )
                );

            }


            // Negative bracket value

            if (
                clean.startsWith("(") &&
                clean.endsWith(")")
            ) {

                return -Math.round(
                    parseFloat(
                        clean
                            .replace(
                                /[()]/g,
                                ''
                            )
                            .replace(
                                /,/g,
                                ''
                            )
                    )
                );

            }


            return (
                Math.round(
                    parseFloat(
                        clean.replace(
                            /,/g,
                            ''
                        )
                    )
                ) || 0
            );

        }


        if (
            typeof val === "number"
        ) {

            return Math.round(
                val
            );

        }


        return 0;

    }


    function formatNumber(num) {

        return Number(num).toLocaleString(
            undefined,
            {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            }
        );

    }


    function formatstring(value) {

        if (
            value === null ||
            value === undefined ||
            value === ""
        ) {

            return "-";

        }


        value =
            value.toString().trim();


        if (
            value.startsWith("(") &&
            value.endsWith(")")
        ) {

            return value;

        }


        const clean =
            value.replace(
                /,/g,
                ''
            );


        if (
            isNaN(clean)
        ) {

            return value;

        }


        return Number(
            clean
        ).toLocaleString();

    }


    // ============================================================
    // CELL VALUE LOOKUP
    // ============================================================

    const getCellValue = (
        op,
        section,
        rowId
    ) => {

        if (
            !op ||
            !Array.isArray(op.data)
        ) {

            return Array(
                periodlabel.length
            ).fill('');

        }


        let currentSection = '';


        for (
            let i = 0;
            i < op.data.length;
            i++
        ) {

            const row =
                op.data[i];


            if (
                !Array.isArray(row)
            ) {

                continue;

            }


            if (
                row.length === 1
            ) {

                currentSection =
                    row[0];

            } else if (
                currentSection === section &&
                row[0] === rowId
            ) {

                return row.slice(1);

            }

        }


        return Array(
            periodlabel.length
        ).fill('');

    };


    // ============================================================
    // BUILD SECTIONS
    //
    // IMPORTANT:
    // This comes AFTER comparisondata.
    // ============================================================

    const sections = [];

    const sectionMapForTable =
        new Map();


    if (
        Array.isArray(comparisondata)
    ) {

        for (
            let i = 0;
            i < comparisondata.length;
            i++
        ) {

            const op =
                comparisondata[i];


            if (
                !op ||
                !Array.isArray(op.data)
            ) {

                continue;

            }


            let currentSection = null;


            for (
                let r = 0;
                r < op.data.length;
                r++
            ) {

                const row =
                    op.data[r];


                if (
                    !Array.isArray(row) ||
                    row.length === 0
                ) {

                    continue;

                }


                if (
                    row.length === 1
                ) {

                    currentSection =
                        row[0];


                    if (
                        !sectionMapForTable.has(
                            currentSection
                        )
                    ) {

                        sectionMapForTable.set(
                            currentSection,
                            []
                        );

                    }

                } else {

                    if (
                        currentSection !== null &&
                        currentSection !== undefined
                    ) {

                        const rowId =
                            row[0];


                        if (
                            rowId !== undefined &&
                            rowId !== null &&
                            rowId !== "" &&
                            !sectionMapForTable
                                .get(currentSection)
                                .includes(rowId)
                        ) {

                            sectionMapForTable
                                .get(currentSection)
                                .push(rowId);

                        }

                    }

                }

            }

        }

    }


    // Convert Map to sections array

    for (
        const sectionEntry of sectionMapForTable.entries()
    ) {

        sections.push({

            name:
                sectionEntry[0],

            rows:
                sectionEntry[1]

        });

    }


    // ============================================================
    // ALL ROWS FOR ADD DROPDOWNS
    // ============================================================

    const allRows =
        sections.reduce(
            (result, section) => {

                if (
                    section &&
                    Array.isArray(
                        section.rows
                    )
                ) {

                    section.rows.forEach(
                        (rowId) => {

                            result.push({

                                value:
                                    rowId,

                                label:
                                    rowId,

                                sectionName:
                                    section.name

                            });

                        }
                    );

                }

                return result;

            },
            []
        );


    // ============================================================
    // FIND SECTION FOR ROW
    // ============================================================

    const findSectionForRow = (
        rowId
    ) => {

        if (
            !Array.isArray(sections)
        ) {

            return null;

        }


        for (
            let i = 0;
            i < sections.length;
            i++
        ) {

            const section =
                sections[i];


            if (
                section &&
                Array.isArray(
                    section.rows
                ) &&
                section.rows.includes(
                    rowId
                )
            ) {

                return section;

            }

        }


        return null;

    };


    // ============================================================
    // ROW FORMULA CALCULATIONS
    // ============================================================

    const rowDependsOn = (
        rowId,
        targetRow,
        visited
    ) => {

        if (!visited) {
            visited = new Set();
        }


        if (
            visited.has(rowId)
        ) {

            return false;

        }


        visited.add(
            rowId
        );


        const formula =
            rowFormulas[rowId];


        if (!formula) {
            return false;
        }


        if (
            !Array.isArray(
                formula.sources
            )
        ) {

            return false;

        }


        for (
            let i = 0;
            i < formula.sources.length;
            i++
        ) {

            const sourceRow =
                formula.sources[i];


            if (
                sourceRow === targetRow
            ) {

                return true;

            }


            if (
                rowDependsOn(
                    sourceRow,
                    targetRow,
                    visited
                )
            ) {

                return true;

            }

        }


        return false;

    };


    // ============================================================
    // CALCULATED CELL VALUES
    // ============================================================

    const getCalculatedCellValues = (
        op,
        sectionName,
        rowId,
        visited
    ) => {

        if (!visited) {
            visited = new Set();
        }


        // --------------------------------------------------------
        // Prevent infinite recursion
        // --------------------------------------------------------

        if (
            visited.has(rowId)
        ) {

            console.warn(
                "Circular formula detected:",
                rowId
            );


            return periodlabel.map(
                () => 0
            );

        }


        const formula =
            rowFormulas[rowId];


        // --------------------------------------------------------
        // No formula
        // --------------------------------------------------------

        if (!formula) {

            return getCellValue(
                op,
                sectionName,
                rowId
            );

        }


        // --------------------------------------------------------
        // ADD FORMULA
        // --------------------------------------------------------

        if (
            (formula.operation === "add" ||
                formula.operation === "divide") &&
            Array.isArray(formula.sources) &&
            (
                (formula.operation === "add" && formula.sources.length === 3) ||
                (formula.operation === "divide" && formula.sources.length === 2)
            )
        ) {
        const newVisited = new Set(visited);

        newVisited.add(rowId);

        const sourceValues = [];

        for (let i = 0; i < formula.sources.length; i++) {
            const sourceRow = formula.sources[i];

            const sourceSection =
                findSectionForRow(sourceRow);

            if (!sourceSection) {
                sourceValues.push(
                    periodlabel.map(() => 0)
                );

                continue;
            }

            sourceValues.push(
                getCalculatedCellValues(
                    op,
                    sourceSection.name,
                    sourceRow,
                    newVisited
                )
            );
        }

    return periodlabel.map((_, index) => {

                const value1 =
                    sourceValues[0] &&
                    sourceValues[0][index] !== undefined
                        ? normalizeValue(sourceValues[0][index])
                        : 0;

                const value2 =
                    sourceValues[1] &&
                    sourceValues[1][index] !== undefined
                        ? normalizeValue(sourceValues[1][index])
                        : 0;
                const value3 =
                    sourceValues[2] &&
                    sourceValues[2][index] !== undefined
                        ? normalizeValue(sourceValues[2][index])
                        : 0;

                if (formula.operation === "divide") {
                    if (value2 === 0) {
                        return 0;
                    }

                    return `${(value1 / value2).toFixed(1)}%`;
                }

                return periodlabel[index];
            });
        }

        if (
            formula.operation === "return_on_equity" &&
            Array.isArray(formula.sources) &&
            formula.sources.length === 3
        ) {
        const newVisited = new Set(visited);
        newVisited.add(rowId);

        const sourceValues = formula.sources.map((source) => {
            const sourceRow =
                typeof source === "string"
                    ? source
                    : source.row;

            const sourceSection = findSectionForRow(sourceRow);

            if (!sourceSection) {
                return periodlabel.map(() => 0);
            }

            return getCalculatedCellValues(
                op,
                sourceSection.name,
                sourceRow,
                newVisited
            );
        });

        return periodlabel.map((_, index) => {
            const source1 = formula.sources[0];
            const source2 = formula.sources[1];
            const source3 = formula.sources[2];

            const value1 = getSourceValueForPeriod(
                sourceValues[0],
                index,
                typeof source1 === "string"
                    ? "current"
                    : source1.periodRule
            );

            const value2 = getSourceValueForPeriod(
                sourceValues[1],
                index,
                typeof source2 === "string"
                    ? "current"
                    : source2.periodRule
            );

            const value3 = getSourceValueForPeriod(
                sourceValues[2],
                index,
                typeof source3 === "string"
                    ? "current"
                    : source3.periodRule
            );

            if(value3 == 0){
                return null;
            }

            const currentPeriod = periodlabel[index];
            // "Sep-25 9M"

            const match = currentPeriod.match(/(\d+)M$/);

            const currentMonthValue = match ? parseInt(match[1], 10) : 0;

            let a = value1 * 12;
            let b = a/currentMonthValue;

            let av = value2 + value3;
            let av2 = av/2;
            let av3 = b/av2;
            let perc = av3*100;
            return `${perc.toFixed(1)}%`

            return b/av2;

            if (value2 === 0) {
                return value3;
            }

            const divisionResult = value1 / value2;

            return currentMonthValue;
        });
        }


        // --------------------------------------------------------
        // FALLBACK
        // --------------------------------------------------------

        return getCellValue(
            op,
            sectionName,
            rowId
        );

    };

    const getPreviousDecemberPeriod = (currentPeriod) => {
    if (!currentPeriod) {
        return null;
    }

    // Example:
    // Jun-25 12M
    // Dec-25 6M
    const match = currentPeriod.match(/^[A-Za-z]{3}-(\d{2})/);

    if (!match) {
        return null;
    }

    const currentYear = parseInt(match[1], 10);
    const previousYear = String(currentYear - 1).padStart(2, "0");

    const previousDecemberPrefix = `Dec-${previousYear}`;

    // Finds:
    // Dec-24 9M
    // Dec-24 12M
    // etc.
    return (
        periodlabel.find((period) =>
            period.startsWith(previousDecemberPrefix)
        ) || null
    );
    };


const getSourceValueForPeriod = (
    sourceValues,
    targetIndex,
    periodRule = "current"
) => {
    if (!sourceValues) {
        return 0;
    }

    // Normal/current-period source
    if (periodRule === "current") {
        return normalizeValue(sourceValues[targetIndex]);
    }

    // Automatically get previous year's December
    if (periodRule === "previousDecember") {
        const currentPeriod = periodlabel[targetIndex];

        const previousDecemberPeriod =
            getPreviousDecemberPeriod(currentPeriod);

        if (!previousDecemberPeriod) {
            return 0;
        }

        const previousDecemberIndex =
            periodlabel.indexOf(previousDecemberPeriod);

        if (previousDecemberIndex === -1) {
            return 0;
        }

        return normalizeValue(
            sourceValues[previousDecemberIndex]
        );
    }

    return 0;
};


    // ============================================================
    // HANDLE ADD ROWS
    // ============================================================

    const handleAddRows = () => {

        if (
            !addSource3 ||
            !addSource4 ||
            !addTarget2
        ) {

            alert(
                "Please select two source rows and one target row."
            );

            return;

        }


        if (
            addSource3 ===
            addSource4
        ) {

            alert(
                "Please select two different source rows."
            );

            return;

        }


        if (
            addTarget2 ===
                addSource3 ||
            addTarget2 ===
                addSource4
        ) {

            alert(
                "Target row must be different from the source rows."
            );

            return;

        }


        // --------------------------------------------------------
        // Circular dependency protection
        // --------------------------------------------------------

        if (
            rowDependsOn(
                addSource3,
                addTarget2
            ) ||
            rowDependsOn(
                addSource4,
                addTarget2
            )
        ) {

            alert(
                "This formula would create a circular dependency."
            );

            return;

        }


        // --------------------------------------------------------
        // Save formula
        // --------------------------------------------------------

        setRowFormulas(
            (previous) => ({

                ...previous,

                [addTarget2]: {

                    operation:
                        "add",

                    sources: [
                        addSource3,
                        addSource4,
                        addSource1
                    ]

                }

            })
        );


        // --------------------------------------------------------
        // Reset
        // --------------------------------------------------------
        setAddSource1("");
        setAddSource3("");
        setAddSource4("");
        setAddTarget2("");

    };

    // const handleDivideRows = () => {

    // if (
    //     !addSource1 ||
    //     !addSource2 ||
    //     !addTarget
    // ) {
    //     alert(
    //         "Please select two source rows and one target row."
    //     );
    //     return;
    // }

    // if (
    //     addSource1 === addSource2
    // ) {
    //     alert(
    //         "Please select two different source rows."
    //     );
    //     return;
    // }

    // if (
    //     addTarget === addSource1 ||
    //     addTarget === addSource2
    // ) {
    //     alert(
    //         "Target row must be different from the source rows."
    //     );
    //     return;
    // }

    // // Circular dependency protection
    // if (
    //     rowDependsOn(addSource1, addTarget) ||
    //     rowDependsOn(addSource2, addTarget)
    // ) {
    //     alert(
    //         "This formula would create a circular dependency."
    //     );
    //     return;
    // }

    // // Save formula
    // setRowFormulas(
    //     previous => ({
    //         ...previous,
    //         [addTarget]: {
    //             operation: "divide",
    //             sources: [
    //                 addSource1,
    //                 addSource2
    //             ]
    //         }
    //     })
    // );

    // // Reset
    // setAddSource1("");
    // setAddSource2("");
    // setAddTarget("");
    // };
    // ============================================================
    // SELECT STYLES
    // ============================================================

    const returnOnEquity = () => {
    // if (!addSource1 || !addSource2 || !addSource3 || !addTarget) {
    //     alert("Please select all rows.");
    //     return;
    // }

    // if (
    //     addSource1 === addTarget ||
    //     addSource2 === addTarget ||
    //     addSource3 === addTarget
    // ) {
    //     alert("Source and target rows cannot be the same.");
    //     return;
    // }

    // if (
    //     rowDependsOn(addSource1, addTarget) ||
    //     rowDependsOn(addSource2, addTarget) ||
    //     rowDependsOn(addSource3, addTarget)
    // ) {
    //     alert("Circular dependency detected.");
    //     return;
    // }

    setRowFormulas((prev) => ({
        ...prev,
        [return_on_equity_target]: {
            operation: "return_on_equity",
            sources: [
                {
                    row: return_on_equity_source1,
                    periodRule: "current",
                },
                {
                    row: return_on_equity_source2,
                    periodRule: "current",
                },
                {
                    row: return_on_equity_source2,
                    periodRule: "previousDecember",
                },
            ],
        },
    }));
    };

    const customStyles = {

        option: (
            provided,
            state
        ) => ({

            ...provided,

            color:
                state.data &&
                state.data.highlight
                    ? 'red'
                    : provided.color

        }),


        singleValue: (
            provided,
            state
        ) => ({

            ...provided,

            color:
                state.data &&
                state.data.highlight
                    ? 'red'
                    : provided.color

        }),


        menu: (
            provided
        ) => ({

            ...provided,

            zIndex: 9999

        })

    };


    const customSelectStyles = {

        menu: (
            provided
        ) => ({

            ...provided,

            zIndex: 9999

        })

    };


    // ============================================================
    // COLUMN WIDTH
    // ============================================================

    useEffect(() => {

        if (
            periodlabel.length === 1
        ) {

            setCOLUMN_WIDTH(
                300
            );

        } else if (
            periodlabel.length === 2
        ) {

            setCOLUMN_WIDTH(
                200
            );

        } else if (
            periodlabel.length > 2
        ) {

            setCOLUMN_WIDTH(
                100
            );

        }

    }, [
        periodlabel.length
    ]);


    // ============================================================
    // EXPORT FOR UPLOADING
    // ============================================================

    const exportToExcel = () => {

        const table =
            document.getElementById(
                "export-table"
            );


        if (!table) {

            alert(
                "Table not found!"
            );

            return;

        }


        const worksheet = {};
        const merges = [];
        const cellMatrix = [];


        const range = {

            s: {
                c: 1000000,
                r: 1000000
            },

            e: {
                c: 0,
                r: 0
            }

        };


        const rows =
            table.querySelectorAll(
                "tr"
            );


        let exportRowIndex = 0;


        rows.forEach(
            (row) => {

                // ----------------------------------------------
                // Ignore row
                // ----------------------------------------------

                if (
                    row.classList.contains(
                        "ignore"
                    )
                ) {

                    return;

                }


                const cells =
                    row.querySelectorAll(
                        "th, td"
                    );


                let colIndex = 0;


                if (
                    !cellMatrix[
                        exportRowIndex
                    ]
                ) {

                    cellMatrix[
                        exportRowIndex
                    ] = [];

                }


                cells.forEach(
                    (cell) => {

                        if (
                            cell.classList.contains(
                                "ignore"
                            )
                        ) {

                            return;

                        }


                        while (
                            cellMatrix[
                                exportRowIndex
                            ][colIndex]
                        ) {

                            colIndex++;

                        }


                        const clonedCell =
                            cell.cloneNode(
                                true
                            );


                        clonedCell
                            .querySelectorAll(
                                ".ignore-excel"
                            )
                            .forEach(
                                (el) =>
                                    el.remove()
                            );


                        const cellText =
                            clonedCell.innerText
                                .trim();


                        const colspan =
                            parseInt(
                                cell.getAttribute(
                                    "colspan"
                                ) || "1",
                                10
                            );


                        const rowspan =
                            parseInt(
                                cell.getAttribute(
                                    "rowspan"
                                ) || "1",
                                10
                            );


                        const cellRef =
                            XLSX.utils.encode_cell({
                                r:
                                    exportRowIndex,

                                c:
                                    colIndex
                            });


                        worksheet[
                            cellRef
                        ] = {

                            v:
                                cellText

                        };


                        // --------------------------------------
                        // Mark occupied cells
                        // --------------------------------------

                        for (
                            let r = 0;
                            r < rowspan;
                            r++
                        ) {

                            for (
                                let c = 0;
                                c < colspan;
                                c++
                            ) {

                                const rr =
                                    exportRowIndex +
                                    r;

                                const cc =
                                    colIndex +
                                    c;


                                if (
                                    !cellMatrix[rr]
                                ) {

                                    cellMatrix[
                                        rr
                                    ] = [];

                                }


                                cellMatrix[
                                    rr
                                ][cc] = true;

                            }

                        }


                        // --------------------------------------
                        // Merge
                        // --------------------------------------

                        if (
                            rowspan > 1 ||
                            colspan > 1
                        ) {

                            merges.push({

                                s: {
                                    r:
                                        exportRowIndex,

                                    c:
                                        colIndex
                                },

                                e: {
                                    r:
                                        exportRowIndex +
                                        rowspan -
                                        1,

                                    c:
                                        colIndex +
                                        colspan -
                                        1
                                }

                            });

                        }


                        range.s.r =
                            Math.min(
                                range.s.r,
                                exportRowIndex
                            );


                        range.s.c =
                            Math.min(
                                range.s.c,
                                colIndex
                            );


                        range.e.r =
                            Math.max(
                                range.e.r,
                                exportRowIndex +
                                rowspan -
                                1
                            );


                        range.e.c =
                            Math.max(
                                range.e.c,
                                colIndex +
                                colspan -
                                1
                            );


                        colIndex +=
                            colspan;

                    }
                );


                exportRowIndex++;

            }
        );


        // --------------------------------------------------------
        // Safety if no cells
        // --------------------------------------------------------

        if (
            range.s.r === 1000000
        ) {

            alert(
                "Nothing to export."
            );

            return;

        }


        worksheet["!ref"] =
            XLSX.utils.encode_range(
                range
            );


        if (
            merges.length
        ) {

            worksheet["!merges"] =
                merges;

        }


        worksheet["!freeze"] = {
            xSplit: "1",
            ySplit: "1"
        };


        const workbook =
            XLSX.utils.book_new();


        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Sheet1"
        );


        const excelBuffer =
            XLSX.write(
                workbook,
                {
                    bookType: "xlsx",
                    type: "array"
                }
            );


        const data =
            new Blob(
                [excelBuffer],
                {
                    type:
                        "application/octet-stream"
                }
            );


        saveAs(
            data,
            "table_export (for uploading).xlsx"
        );

    };


    // ============================================================
    // NORMAL EXPORT
    // ============================================================

    const normalexportToExcel = () => {

        const table =
            document.getElementById(
                "export-table"
            );


        if (!table) {

            alert(
                "Table not found!"
            );

            return;

        }


        const worksheet = {};
        const merges = [];
        const cellMatrix = [];


        const range = {

            s: {
                c: 1000000,
                r: 1000000
            },

            e: {
                c: 0,
                r: 0
            }

        };


        const rows =
            table.querySelectorAll(
                "tr"
            );


        let exportRowIndex = 0;


        rows.forEach(
            (row) => {

                if (
                    row.classList.contains(
                        "ignore2"
                    )
                ) {

                    return;

                }


                const cells =
                    row.querySelectorAll(
                        "th, td"
                    );


                let colIndex = 0;


                if (
                    !cellMatrix[
                        exportRowIndex
                    ]
                ) {

                    cellMatrix[
                        exportRowIndex
                    ] = [];

                }


                cells.forEach(
                    (cell) => {

                        if (
                            cell.classList.contains(
                                "ignore2"
                            )
                        ) {

                            return;

                        }


                        while (
                            cellMatrix[
                                exportRowIndex
                            ][colIndex]
                        ) {

                            colIndex++;

                        }


                        const clonedCell =
                            cell.cloneNode(
                                true
                            );


                        clonedCell
                            .querySelectorAll(
                                ".ignore-excel"
                            )
                            .forEach(
                                (el) =>
                                    el.remove()
                            );


                        const cellText =
                            clonedCell.innerText
                                .trim();


                        const colspan =
                            parseInt(
                                cell.getAttribute(
                                    "colspan"
                                ) || "1",
                                10
                            );


                        const rowspan =
                            parseInt(
                                cell.getAttribute(
                                    "rowspan"
                                ) || "1",
                                10
                            );


                        const cellRef =
                            XLSX.utils.encode_cell({
                                r:
                                    exportRowIndex,

                                c:
                                    colIndex
                            });


                        worksheet[
                            cellRef
                        ] = {

                            v:
                                cellText

                        };


                        for (
                            let r = 0;
                            r < rowspan;
                            r++
                        ) {

                            for (
                                let c = 0;
                                c < colspan;
                                c++
                            ) {

                                const rr =
                                    exportRowIndex +
                                    r;

                                const cc =
                                    colIndex +
                                    c;


                                if (
                                    !cellMatrix[rr]
                                ) {

                                    cellMatrix[
                                        rr
                                    ] = [];

                                }


                                cellMatrix[
                                    rr
                                ][cc] = true;

                            }

                        }


                        if (
                            rowspan > 1 ||
                            colspan > 1
                        ) {

                            merges.push({

                                s: {
                                    r:
                                        exportRowIndex,

                                    c:
                                        colIndex
                                },

                                e: {
                                    r:
                                        exportRowIndex +
                                        rowspan -
                                        1,

                                    c:
                                        colIndex +
                                        colspan -
                                        1
                                }

                            });

                        }


                        range.s.r =
                            Math.min(
                                range.s.r,
                                exportRowIndex
                            );


                        range.s.c =
                            Math.min(
                                range.s.c,
                                colIndex
                            );


                        range.e.r =
                            Math.max(
                                range.e.r,
                                exportRowIndex +
                                rowspan -
                                1
                            );


                        range.e.c =
                            Math.max(
                                range.e.c,
                                colIndex +
                                colspan -
                                1
                            );


                        colIndex +=
                            colspan;

                    }
                );


                exportRowIndex++;

            }
        );


        if (
            range.s.r === 1000000
        ) {

            alert(
                "Nothing to export."
            );

            return;

        }


        worksheet["!ref"] =
            XLSX.utils.encode_range(
                range
            );


        if (
            merges.length
        ) {

            worksheet["!merges"] =
                merges;

        }


        worksheet["!freeze"] = {
            xSplit: "1",
            ySplit: "1"
        };


        const workbook =
            XLSX.utils.book_new();


        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Sheet1"
        );


        const excelBuffer =
            XLSX.write(
                workbook,
                {
                    bookType: "xlsx",
                    type: "array"
                }
            );


        const data =
            new Blob(
                [excelBuffer],
                {
                    type:
                        "application/octet-stream"
                }
            );


        saveAs(
            data,
            "table_export (for normal usage).xlsx"
        );

    };


    // ============================================================
    // UPLOAD FILE
    // ============================================================

    const UploadFile = async () => {

        try {

            setalertOpen(false);


            if (
                !inputRef.current ||
                !inputRef.current.files ||
                inputRef.current.files.length === 0
            ) {

                setalertOpen(true);

                setalertType(
                    "error"
                );

                setalertmessage(
                    "Please select an Excel file."
                );

                return;

            }


            const file =
                inputRef.current.files[0];


            const fileData =
                new FormData();


            fileData.append(
                "file",
                file
            );


            const res =
                await axios.post(
                    `${url3}/api/research_new_period`,
                    fileData,
                    {
                        headers: {
                            "Content-Type":
                                "multipart/form-data"
                        }
                    }
                );


            const resp =
                res.data;


            if (
                resp.status === true
            ) {

                setperiodlabel([]);

                setperiod([]);

                setselectedPeriod([]);

                setcomparisondata([]);

                setrowFormulasAndReset();


                await func();


            } else {

                setalertOpen(true);

                setalertType(
                    'error'
                );

                setalertmessage(
                    resp.message
                );

            }

        } catch (error) {

            console.error(
                "Upload error:",
                error
            );


            setalertOpen(true);

            setalertType(
                "error"
            );

            setalertmessage(
                "Error uploading file."
            );

        }

    };


    // ============================================================
    // RESET FORMULAS AFTER UPLOAD
    // ============================================================

    const setrowFormulasAndReset = () => {

        setRowFormulas({});

        setAddSource1("");

        setAddSource2("");

        setAddTarget("");

    };
    // ============================================================
    // RENDER
    // ============================================================

    return (

        <div
            style={
                loading === 'loading'
                    ? {
                        height: '90vh'
                    }
                    : null
            }
        >

            {/* ====================================================
                TITLE
            ==================================================== */}

            <div
                className='fs-3 fw-bold text-center mt-2 mb-3'
                style={{
                    color: "#000078"
                }}
            >
                Financial Sheet Data
            </div>


            {/* ====================================================
                LOADED
            ==================================================== */}

            {
                loading === 'loaded'
                    ?

                    <>

                        {/* ====================================================
                            FILTER BUTTONS
                        ==================================================== */}

                        <button
                            className="btn btn-primary ms-1"
                            onClick={() =>
                                setShowFilters(
                                    !showFilters
                                )
                            }
                        >

                            {
                                showFilters
                                    ? "Close Filters"
                                    : "Open Filters"
                            }

                        </button>


                        <button
                            className="btn btn-primary ms-1"
                            onClick={() =>
                                setHiddenPeriods({})
                            }
                        >
                            Remove Period Filters
                        </button>

 . 
                        {/* ====================================================
                            FILTERS
                        ==================================================== */}

                        {
                            showFilters && (

                                <div
                                    className='col-12 card shadow' 
                                >

                                    {/* GROUP */}

                                    <div
                                        className='col-12 col-lg-6 col-md-6 m-2'
                                    >

                                        <Select
                                            options={
                                                group
                                            }
                                            placeholder="Select Group" 
                                            value={
                                                selectedGroup
                                            }
                                            onChange={
                                                handleSelect
                                            }
                                            isSearchable={
                                                true
                                            }
                                        />

                                    </div>


                                    {/* CLUSTER */}

                                    <div
                                        className='col-12 col-lg-6 col-md-6 m-2'
                                    >

                                        <Select
                                            options={
                                                mainsector
                                            }
                                            placeholder="Select Cluster"
                                            value={
                                                selectedMainSector
                                            }
                                            onChange={
                                                handleSelect2
                                            }
                                            styles={
                                                customSelectStyles
                                            }
                                            isSearchable={
                                                true
                                            }
                                        />

                                    </div>


                                    {/* SECTOR */}

                                    <div
                                        className='col-12 col-lg-6 col-md-6 m-2'
                                    >

                                        <Select
                                            options={
                                                sector
                                            }
                                            placeholder="Select Sector"
                                            value={
                                                selectedSector
                                            }
                                            onChange={
                                                handleSelect3
                                            }
                                            styles={
                                                customSelectStyles
                                            }
                                            isSearchable={
                                                true
                                            }
                                        />

                                    </div>


                                    {/* SCALE */}

                                    <div
                                        className='col-12 col-lg-6 col-md-6 m-2'
                                    >

                                        <Select
                                            options={
                                                scale
                                            }
                                            placeholder="Select Rating Type"
                                            value={
                                                selectedScale
                                            }
                                            onChange={
                                                handleSelect4
                                            }
                                            styles={
                                                customSelectStyles
                                            }
                                            isSearchable={
                                                true
                                            }
                                            isMulti
                                        />

                                    </div>


                                    {/* OPINION */}

                                    <div
                                        className='col-12 col-lg-6 col-md-6 m-2'
                                    >

                                        <Select
                                            options={
                                                opinion
                                            }
                                            placeholder="Select Opinion"
                                            value={
                                                selectedOpinion
                                            }
                                            onChange={
                                                handleSelect5
                                            }
                                            styles={
                                                customSelectStyles
                                            }
                                            isSearchable={
                                                true
                                            }
                                            closeMenuOnSelect={
                                                false
                                            }
                                            isMulti
                                        />

                                    </div>


                                    {/* PERIOD */}

                                    <div
                                        className='col-12 col-lg-6 col-md-6 m-2'
                                    >

                                        <Select
                                            options={
                                                period
                                            }
                                            placeholder="Select Period"
                                            value={
                                                selectedPeriod
                                            }
                                            styles={
                                                customStyles
                                            }
                                            onChange={
                                                handleSelect6
                                            }
                                            isSearchable={
                                                true
                                            }
                                            closeMenuOnSelect={
                                                false
                                            }
                                            isMulti
                                        />

                                    </div>

                                </div>

                            )
                        }


                        {/* ====================================================
                            TABLE ONLY WHEN PERIOD SELECTED
                        ==================================================== */}

                        {
                            periodlabel.length > 0 && (

                                <>

                                    {/* ====================================================
                                        EXPORT BUTTONS
                                    ==================================================== */}

                                    <div
                                        className='mt-3'
                                    >

                                        <button
                                            className='btn btn-primary'
                                            onClick={
                                                exportToExcel
                                            }
                                            style={{
                                                marginBottom:
                                                    '10px'
                                            }}
                                        >
                                            Export Table to Excel (For Uploading)
                                        </button>


                                        <button
                                            className='btn btn-success ms-1'
                                            onClick={
                                                normalexportToExcel
                                            }
                                            style={{
                                                marginBottom:
                                                    '10px'
                                            }}
                                        >
                                            Export Table to Excel (For Normal Usage)
                                        </button>

                                    </div>


                                    {/* ====================================================
                                        UPLOAD
                                    ==================================================== */}

                                    <div
                                        className='mt-2 col-6'
                                    >

                                        <input
                                            className='form-control'
                                            type='file'
                                            accept=".xls,.xlsx"
                                            ref={
                                                inputRef
                                            }
                                        />


                                        <div>

                                            <Box
                                                className="mx-auto"
                                                sx={{
                                                    width: "98%"
                                                }}
                                            >

                                                <Collapse
                                                    in={
                                                        alertopen
                                                    }
                                                >

                                                    <Alert
                                                        severity={
                                                            alertType
                                                        }
                                                        action={

                                                            <IconButton
                                                                aria-label="close"
                                                                color="inherit"
                                                                size="small"
                                                                onClick={() =>
                                                                    setalertOpen(
                                                                        false
                                                                    )
                                                                }
                                                            >

                                                                <CloseIcon
                                                                    fontSize="inherit"
                                                                />

                                                            </IconButton>

                                                        }
                                                        sx={{
                                                            mb: 2
                                                        }}
                                                    >

                                                        {
                                                            AlertMessage
                                                        }

                                                    </Alert>

                                                </Collapse>

                                            </Box>

                                        </div>


                                        <div>

                                            <button
                                                className='btn btn-primary'
                                                onClick={
                                                    UploadFile
                                                }
                                            >
                                                Save
                                            </button>

                                        </div>

                                    </div>


                                    {/* ====================================================
                                        COUNTS
                                    ==================================================== */}

                                    <div
                                        className="card p-3 mt-4 d-flex align-items-center flex-nowrap"
                                        style={{
                                            width:
                                                "fit-content",
                                            whiteSpace:
                                                "nowrap"
                                        }}
                                    >

                                        <span>
                                            <b>PACRA:</b>{" "}
                                            {pacra}
                                        </span>

                                        <span
                                            className="ms-3"
                                        >
                                            <b>VIS:</b>{" "}
                                            {vis}
                                        </span>

                                        <span
                                            className="ms-3"
                                        >
                                            <b>Other:</b>{" "}
                                            {other}
                                        </span>

                                    </div>


                                    {/* ====================================================
                                        ROW ADDITION CONTROLS
                                    ==================================================== */}

                                    <div
                                        className="card shadow col-12 mx-auto mb-3"
                                        style={{
                                            padding:
                                                "15px",
                                            border:
                                                "1px solid #ccc"
                                        }}
                                    >

                                        <div
                                            style={{
                                                display:
                                                    "flex",
                                                alignItems:
                                                    "flex-end",
                                                gap:
                                                    "15px",
                                                flexWrap:
                                                    "wrap"
                                            }}
                                        >

                                            {/* SOURCE 1 */}

                                            <div
                                                style={{
                                                    display:
                                                        "flex",
                                                    flexDirection:
                                                        "column",
                                                    minWidth:
                                                        "250px"
                                                }}
                                            >

                                                <label
                                                    style={{
                                                        fontWeight:
                                                            "bold",
                                                        marginBottom:
                                                            "5px"
                                                    }}
                                                >
                                                    Add Row 1
                                                </label>


                                                <select
                                                    value={
                                                        addSource1
                                                    }
                                                    onChange={
                                                        (e) =>
                                                            setAddSource1(
                                                                e.target.value
                                                            )
                                                    }
                                                    className="form-select"
                                                >

                                                    <option
                                                        value=""
                                                    >
                                                        Select first row
                                                    </option>


                                                    {
                                                        allRows.map(
                                                            (row) => (

                                                                <option
                                                                    key={
                                                                        `source1-${row.sectionName}-${row.value}`
                                                                    }
                                                                    value={
                                                                        row.value
                                                                    }
                                                                >
                                                                    {
                                                                        row.label
                                                                    }
                                                                </option>

                                                            )
                                                        )
                                                    }

                                                </select>

                                            </div>


                                            {/* SOURCE 2 */}

                                            <div
                                                style={{
                                                    display:
                                                        "flex",
                                                    flexDirection:
                                                        "column",
                                                    minWidth:
                                                        "250px"
                                                }}
                                            >

                                                <label
                                                    style={{
                                                        fontWeight:
                                                            "bold",
                                                        marginBottom:
                                                            "5px"
                                                    }}
                                                >
                                                    Add Row 2
                                                </label>


                                                <select
                                                    value={
                                                        addSource2
                                                    }
                                                    onChange={
                                                        (e) =>
                                                            setAddSource2(
                                                                e.target.value
                                                            )
                                                    }
                                                    className="form-select"
                                                >

                                                    <option
                                                        value=""
                                                    >
                                                        Select second row
                                                    </option>


                                                    {
                                                        allRows.map(
                                                            (row) => (

                                                                <option
                                                                    key={
                                                                        `source2-${row.sectionName}-${row.value}`
                                                                    }
                                                                    value={
                                                                        row.value
                                                                    }
                                                                >
                                                                    {
                                                                        row.label
                                                                    }
                                                                </option>

                                                            )
                                                        )
                                                    }

                                                </select>

                                            </div>


                                            {/* TARGET */}

                                            <div
                                                style={{
                                                    display:
                                                        "flex",
                                                    flexDirection:
                                                        "column",
                                                    minWidth:
                                                        "250px"
                                                }}
                                            >

                                                <label
                                                    style={{
                                                        fontWeight:
                                                            "bold",
                                                        marginBottom:
                                                            "5px"
                                                    }}
                                                >
                                                    Add Into Row
                                                </label>


                                                <select
                                                    value={
                                                        addTarget
                                                    }
                                                    onChange={
                                                        (e) =>
                                                            setAddTarget(
                                                                e.target.value
                                                            )
                                                    }
                                                    className="form-select"
                                                >

                                                    <option
                                                        value=""
                                                    >
                                                        Select target row
                                                    </option>


                                                    {
                                                        allRows.map(
                                                            (row) => (

                                                                <option
                                                                    key={
                                                                        `target-${row.sectionName}-${row.value}`
                                                                    }
                                                                    value={
                                                                        row.value
                                                                    }
                                                                >
                                                                    {
                                                                        row.label
                                                                    }
                                                                </option>

                                                            )
                                                        )
                                                    }

                                                </select>

                                            </div>


                                            {/* ADD BUTTON */}

                                            <div>

                                                <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={
                                                        returnOnEquity
                                                    }
                                                    ref={rationRef}
                                                    disabled={
                                                        !addSource1 ||
                                                        !addSource2 ||
                                                        !addTarget
                                                    }
                                                >
                                                    Calculate Ratio
                                                </button>

                                            </div>

                                        </div>


                                        {/* ====================================================
                                            ACTIVE FORMULAS
                                        ==================================================== */}

                                        {
                                            Object.keys(
                                                rowFormulas
                                            ).length > 0 && (

                                                <div
                                                    style={{
                                                        marginTop:
                                                            "15px",
                                                        paddingTop:
                                                            "10px",
                                                        borderTop:
                                                            "1px solid #ddd"
                                                    }}
                                                >

                                                    <strong>
                                                        Applied Row Formulas:
                                                    </strong>


                                                    <div
                                                        style={{
                                                            marginTop:
                                                                "8px"
                                                        }}
                                                    >

                                                        {
                                                            Object.entries(
                                                                rowFormulas
                                                            ).map(
                                                                (
                                                                    entry
                                                                ) => {

                                                                    const targetRow =
                                                                        entry[0];

                                                                    const formula =
                                                                        entry[1];


                                                                    return (

                                                                        <div
                                                                            key={
                                                                                targetRow
                                                                            }
                                                                            style={{
                                                                                display:
                                                                                    "flex",
                                                                                alignItems:
                                                                                    "center",
                                                                                gap:
                                                                                    "10px",
                                                                                marginBottom:
                                                                                    "5px"
                                                                            }}
                                                                        >

                                                                            <span>

                                                                                <b>
                                                                                    {
                                                                                        targetRow
                                                                                    }
                                                                                </b>

                                                                                {" = "}

                                                                                {
                                                                                    formula.sources.join(
                                                                                        " / "
                                                                                    )
                                                                                }

                                                                            </span>


                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-danger"
                                                                                onClick={() => {

                                                                                    setRowFormulas(
                                                                                        (
                                                                                            previous
                                                                                        ) => {

                                                                                            const updated =
                                                                                                {
                                                                                                    ...previous
                                                                                                };


                                                                                            delete updated[
                                                                                                targetRow
                                                                                            ];


                                                                                            return updated;

                                                                                        }
                                                                                    );

                                                                                }}
                                                                            >
                                                                                Remove
                                                                            </button>

                                                                        </div>

                                                                    );

                                                                }
                                                            )
                                                        }

                                                    </div>

                                                </div>

                                            )
                                        }

                                    </div>


                                    {/* ====================================================
                                        TABLE CONTAINER
                                    ==================================================== */}

                                    <div
                                        className="card shadow col-12 mx-auto table-container"
                                        style={{
                                            overflowX:
                                                "auto",
                                            maxWidth:
                                                "100%",
                                            paddingBottom:
                                                "10px",
                                            maxHeight:
                                                "500px",
                                            overflowY:
                                                "auto",
                                            border:
                                                "1px solid #ccc"
                                        }}
                                    >

                                        <table
                                            className="sticky-table"
                                            id="export-table"
                                        >

                                            {/* ==================================================
                                                TABLE HEAD
                                            ================================================== */}

                                          <thead>
                          <tr className='ignore2' hidden={true}>
                            <th colSpan={5}> <b>Note:</b>  Listed = 5 Unlisted = 7</th>
                          </tr>
                          <tr className='ignore2' hidden={true}>
                            <th>{selectedGroup.label}</th>
                          </tr>
                          <tr className='ignore2' hidden={true}>
                            <th>{selectedMainSector.label}</th>
                          </tr>
                          <tr className='ignore2' hidden={true}>
                            <th>{selectedSector.label}</th>
                          </tr>
                          <tr className='ignore2' hidden={true}>
                              <th className="">Opinion ID</th>
                              {comparisondata.map((op) => (
                              <th
                                  key={op.name}
                                  colSpan={getVisiblePeriods(op.name).length}
                                  className="sticky-header-top-0 text-align"
                                  style={{
                                  minWidth: `${periodlabel.length * 100}px`,
                                  backgroundColor: '#e0e0e0',
                                  minWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  maxWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  width: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  }}
                              >
                                {op.opinion_id}
                              </th>
                              ))}
                             
                              {periodlabel.map((k) => (
                                  <th className="ignore" style={{ minWidth: '120px', textAlign:"center !important", }}> </th>
                              ))}

                              {periodlabel.map((k) => (
                                  <th className="ignore" style={{ minWidth: '120px', textAlign:"center !important", }}></th>
                              ))}

                          </tr>
                          <tr className='ignore2' hidden={true}>
                              <th className="">Listed/Unlisted</th>
                              {comparisondata.map((op) => (
                              <th
                                  key={op.name}
                                  colSpan={getVisiblePeriods(op.name).length}
                                  className="sticky-header-top-0 text-align"
                                  style={{
                                  minWidth: `${periodlabel.length * 100}px`,
                                  backgroundColor: '#e0e0e0',
                                  minWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  maxWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  width: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  }}
                              >
                                {op.legal_status}
                              </th>
                              ))}

                              {periodlabel.map((k) => (
                                  <th className="ignore sticky-header-left-0" style={{ minWidth: '120px', textAlign:"center !important", }}></th>
                              ))}
                              {periodlabel.map((k) => (
                                  <th className="ignore sticky-header-left-0" style={{ minWidth: '120px', textAlign:"center !important", }}></th>
                              ))}

                          </tr>
                          <tr className='ignore'>
                            <th className="sticky-header-left-0">PACRA/VIS/Other</th>
                            {comparisondata.map((op) => (
                              <th
                                  key={op.name}
                                  colSpan={getVisiblePeriods(op.name).length}
                                  className="text-align"
                                  style={{
                                  minWidth: `${periodlabel.length * 100}px`,
                                  backgroundColor: '#e0e0e0',
                                  minWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  maxWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  width: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  }}
                              >
                                  {op.opinion} {op.legal_status == 5 ? '| Listed' : op.legal_status == 7 ? '| Unlisted' : null}
                              </th>
                              ))}

                                {periodlabel.map((label) => (
                              <th
                                  key={`total-${label}`}
                                  className="sticky-header-top-0 text-align ignore"
                                  
                                  style={{ minWidth: '120px', backgroundColor: '#d0d0d0', textAlign:"center !important", }}
                              >
                                
                              </th>
                              ))}
                              {periodlabel.map((label) => (
                              <th
                                  key={`avg-${label}`}
                                  className="sticky-header-top-0 text-align ignore"
                                  style={{ minWidth: '120px', backgroundColor: '#c0c0c0', textAlign:"center !important", }}
                              >
                                
                              </th>
                              ))}
                          </tr>
                          <tr hidden={true} className='ignore2'>
                            <th className="sticky-header-top-0 sticky-header-left-0">PACRA/VIS/Other</th>
                            {comparisondata.map((op) => (
                              <th
                                  key={op.name}
                                  colSpan={getVisiblePeriods(op.name).length}
                                  className="sticky-header-top-0 text-align"
                                  style={{
                                  minWidth: `${periodlabel.length * 100}px`,
                                  backgroundColor: '#e0e0e0',
                                  minWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  maxWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  width: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  }}
                              >
                                  {op.opinion}
                              </th>
                              ))}

                                {periodlabel.map((label) => (
                              <th
                                  key={`total-${label}`}
                                  className="sticky-header-top-0 text-align ignore"
                                  
                                  style={{ minWidth: '120px', backgroundColor: '#d0d0d0', textAlign:"center !important", }}
                              >
                              </th>
                              ))}
                              {periodlabel.map((label) => (
                              <th
                                  key={`avg-${label}`}
                                  className="sticky-header-top-0 text-align ignore"
                                  style={{ minWidth: '120px', backgroundColor: '#c0c0c0', textAlign:"center !important", }}
                              >
                              </th>
                              ))}
                          </tr>
                          <tr>
                            <th className="sticky-header-left-top-0"></th>
                            {comparisondata.map((op) => (
                              <th
                                  key={op.name}
                                  colSpan={getVisiblePeriods(op.name).length}
                                  className="sticky-header-top-0 text-align"
                                  style={{
                                  minWidth: `${periodlabel.length * 100}px`,
                                  backgroundColor: '#e0e0e0',
                                  minWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  maxWidth: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  width: `${periodlabel.length * COLUMN_WIDTH}px`,
                                  }}
                              >
                                  {op.name}
                              </th>
                              ))}

                                {periodlabel.map((label) => (
                              <th
                                  key={`total-${label}`}
                                  className="sticky-header-top-0 text-align ignore"
                                  rowSpan="2"
                                  style={{ minWidth: '120px', backgroundColor: '#d0d0d0', textAlign:"center !important", }}
                              >
                                  Total Sum {" "} <br /> {` ${label}`}
                              </th>
                              ))}
                              
                              {periodlabel.map((label) => (
                              <th
                                  key={`avg-${label}`}
                                  className="sticky-header-top-0 text-align ignore"
                                  rowSpan="2"
                                  style={{ minWidth: '120px', backgroundColor: '#c0c0c0', textAlign:"center !important", }}
                              >
                                  Average <br /> {` ${label}`} 
                              </th>
                              ))}
                          </tr>
                          <tr>

                              <th
                                  className="sticky-header-left-top-1 text-align"
                                  style={{
                                      width: `${COLUMN_WIDTH}px`,
                                      minWidth: `${COLUMN_WIDTH}px`,
                                      textAlign: "center"
                                  }}
                              >
                              </th>


                              {comparisondata.map((op) => {

                                  const visiblePeriods =
                                      getVisiblePeriods(op.name);

                                  return visiblePeriods.map((period) => (

                                      <th
                                          key={`${op.opinion_id}-${period}`}
                                          className="text-align sticky-header-top-1"
                                          style={{
                                              width: `${COLUMN_WIDTH}px`,
                                              minWidth: `${COLUMN_WIDTH}px`
                                          }}
                                      >

                                          <div
                                              style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  gap: "8px"
                                              }}
                                          >

                                              <span>
                                                  {period}
                                              </span>

                                              <button
                                                  type="button"
                                                  className="ignore-excel"
                                                  onClick={() =>
                                                      togglePeriod(
                                                          op.name,
                                                          period
                                                      )
                                                  }
                                                  style={{
                                                      border: "none",
                                                      background: "transparent",
                                                      cursor: "pointer",
                                                      color: "red",
                                                      fontWeight: "bold",
                                                      fontSize: "16px",
                                                      padding: "0"
                                                  }}
                                                  title={`Hide ${period} from ${op.name}`}
                                              >
                                                  ×
                                              </button>

                                          </div>

                                      </th>

                                  ));

                              })}

                          </tr>
                          </thead>
                                                  <tbody>

                                                      {sections.map((section) => (

                                                          <React.Fragment key={section.name}>

                                                              {/* SECTION HEADER */}

                                                              <tr className="ignore ignore2">

                                                                  <td
                                                                      colSpan={1}
                                                                      className="section-header ignore ignore2 sticky-header-left-0"
                                                                  >
                                                                      {section.name}
                                                                  </td>

                                                                  <td
                                                                      colSpan={
                                                                          comparisondata.reduce(
                                                                              (total, op) =>
                                                                                  total +
                                                                                  getVisiblePeriods(op.name).length,
                                                                              0
                                                                          )
                                                                      }
                                                                      className="section-header ignore ignore2"
                                                                  />

                                                                  <td
                                                                      className="section-header ignore ignore2"
                                                                      colSpan={periodlabel.length * 2}
                                                                  />

                                                              </tr>


                                                              {/* ROWS */}

                                                              {section.rows.map((rowId) => (

                                                                  <tr key={rowId}>

                                                                      {/* ROW NAME */}

                                                                      <td
                                                                          className="sticky-header-left-0"
                                                                          style={{
                                                                              fontWeight: "bold",
                                                                              minWidth: "400px",
                                                                              textAlign: "left"
                                                                          }}
                                                                      >
                                                                          {rowId}

                                                                          {rowFormulas[rowId] && (
                                                                              <span
                                                                              className='ignore-excel'
                                                                                  title={
                                                                                      "Calculated: " +
                                                                                      rowFormulas[rowId].sources.join(" + ")
                                                                                  }
                                                                                  style={{
                                                                                      marginLeft: "6px",
                                                                                      color: "#0d6efd",
                                                                                      fontWeight: "bold"
                                                                                  }}
                                                                              >
                                                                                  ƒ
                                                                              </span>
                                                                          )}
                                                                      </td>


                                                                      {/* OPINION VALUES */}

                                                                      {comparisondata.map((op) => {

                                                                          const values =
                                                                              getCalculatedCellValues(
                                                                                  op,
                                                                                  section.name,
                                                                                  rowId
                                                                              );

                                                                          const visiblePeriods =
                                                                              getVisiblePeriods(op.name);

                                                                          return visiblePeriods.map((currentPeriod) => {

                                                                              const originalIndex =
                                                                                  periodlabel.indexOf(currentPeriod);

                                                                              const val =
                                                                                  values[originalIndex];

                                                                              return (
                                                                                  <td
                                                                                      key={
                                                                                          op.opinion_id +
                                                                                          "-" +
                                                                                          currentPeriod +
                                                                                          "-" +
                                                                                          rowId
                                                                                      }
                                                                                      className="text-align"
                                                                                      style={{
                                                                                          width: `${COLUMN_WIDTH}px`,
                                                                                          minWidth: `${COLUMN_WIDTH}px`,
                                                                                          textAlign: "center"
                                                                                      }}
                                                                                  >
                                                                                      {
                                                                                          val == 0
                                                                                              ? "-"
                                                                                              : val == ""
                                                                                                  ? " "
                                                                                                  : val == "0"
                                                                                                      ? "-"
                                                                                                      : formatstring(val)
                                                                                      }
                                                                                  </td>
                                                                              );

                                                                          });

                                                                      })}


                                                                      {/* TOTAL */}

                                                                      {periodlabel.map((currentPeriod) => {

                                                                          const valuesForPeriod = [];

                                                                          comparisondata.forEach((op) => {

                                                                              if (
                                                                                  isPeriodHidden(
                                                                                      op.name,
                                                                                      currentPeriod
                                                                                  )
                                                                              ) {
                                                                                  return;
                                                                              }

                                                                              const values =
                                                                                  getCalculatedCellValues(
                                                                                      op,
                                                                                      section.name,
                                                                                      rowId
                                                                                  );

                                                                              const originalIndex =
                                                                                  periodlabel.indexOf(currentPeriod);

                                                                              valuesForPeriod.push(
                                                                                  normalizeValue(
                                                                                      values[originalIndex]
                                                                                  )
                                                                              );

                                                                          });

                                                                          const total =
                                                                              valuesForPeriod.reduce(
                                                                                  (a, b) => a + b,
                                                                                  0
                                                                              );

                                                                          return (
                                                                              <td
                                                                                  key={
                                                                                      `total-${currentPeriod}-${rowId}`
                                                                                  }
                                                                                  className="text-align ignore"
                                                                                  style={{
                                                                                      textAlign: "center"
                                                                                  }}
                                                                              >
                                                                                  {formatNumber(total)}
                                                                              </td>
                                                                          );

                                                                      })}


                                                                      {/* AVERAGE */}

                                                                      {periodlabel.map((currentPeriod) => {

                                                                          const valuesForPeriod = [];

                                                                          comparisondata.forEach((op) => {
                                                                                // Skip opinions that do not contain this period
                                                                                if (
                                                                                !Array.isArray(op.periods) ||
                                                                                !op.periods.includes(currentPeriod)
                                                                                ) {
                                                                                return;
                                                                                }

                                                                                // Skip periods hidden by the user
                                                                                if (isPeriodHidden(op.name, currentPeriod)) {
                                                                                    return;
                                                                                }

                                                                                const values = getCalculatedCellValues(
                                                                                    op,
                                                                                    section.name,
                                                                                    rowId
                                                                                );

                                                                                const originalIndex = periodlabel.indexOf(currentPeriod);

                                                                                valuesForPeriod.push(
                                                                                    normalizeValue(values[originalIndex])
                                                                                );

                                                                                });

                                                                          const avg =
                                                                              valuesForPeriod.length > 0
                                                                                  ? valuesForPeriod.reduce(
                                                                                      (a, b) => a + b,
                                                                                      0
                                                                                  ) /
                                                                                    valuesForPeriod.length
                                                                                  : 0;

                                                                          return (
                                                                              <td
                                                                                  key={
                                                                                      `avg-${currentPeriod}-${rowId}`
                                                                                  }
                                                                                  className="text-align ignore"
                                                                                  style={{
                                                                                      textAlign: "center"
                                                                                  }}
                                                                              >
                                                                                  {formatNumber(avg)}
                                                                              </td>
                                                                          );

                                                                      })}

                                                                  </tr>

                                                              ))}

                                                          </React.Fragment>

                                                      ))}

                                                  </tbody>

                                        </table>
                                     </div>
                                </>
                            )

                        }
                    </>
                :
                   (<div className="mt-5 mx-auto" style={{ width: "fit-content" }}>
                      <div class="wrapper" id="loader2">
                        <svg
                          class="hourglass"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 120 206"
                          preserveAspectRatio="none"
                        >
                          <path
                            class="middle"
                            d="M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"
                          />
                          <path
                            class="outer"
                            d="M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"
                          />
                        </svg>
                      </div>
                    </div>)
            }
   
        
      
            <div/>
    
  
      </div>
    )



}